var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import BasicArcheivesService from '../../../api/BasicArcheivesService';
var CategoryTable = (function (_super) {
    __extends(CategoryTable, _super);
    function CategoryTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableData = [];
        _this.stPickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now();
            }
        };
        _this.isAllEdit = false;
        _this.stCurrentPickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            }
        };
        _this.stNextPickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now();
            }
        };
        return _this;
    }
    CategoryTable.prototype.setCurrentEtPickerOptions = function (row) {
        var eTime = new Date(row.current.es_time);
        eTime.setHours(0, 0, 0, 0);
        return {
            disabledDate: function (time) {
                if (!row.current.es_time) {
                    return time.getTime() < Date.now();
                }
                return time.getTime() < eTime;
            }
        };
    };
    CategoryTable.prototype.setNextEtPickerOptions = function (row) {
        var eTime = new Date(row.next.es_time);
        eTime.setHours(0, 0, 0, 0);
        return {
            disabledDate: function (time) {
                if (!row.next.es_time) {
                    return time.getTime() < Date.now();
                }
                return time.getTime() < eTime;
            }
        };
    };
    CategoryTable.prototype.created = function () {
        this.basicArcheivesService = BasicArcheivesService.getInstance();
    };
    CategoryTable.prototype.selectionChange = function (rows) {
        this.$emit('setSelectRows', rows);
    };
    CategoryTable.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'ASC' : 'DESC'];
        }
        this.$emit('sortChange', this.order);
    };
    CategoryTable.prototype.validateNumericInput = function (row, field, fieldName, minValue, maxValue) {
        var value = row[field];
        if (value !== null && value !== undefined && value !== '') {
            var regex = /^(\d*\.\d{0,2}|\d+)$/;
            if (!regex.test(value)) {
                this.$message.error("\u8BF7\u8F93\u5165\u6570\u5B57\uFF0C\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C" + fieldName + "\u5FC5\u987B\u5728" + minValue + "\u548C" + maxValue + "\u4E4B\u95F4");
                row[field] = '';
            }
            if (parseFloat(value) < minValue) {
                this.$message.error("\u8BF7\u8F93\u5165\u6570\u5B57\uFF0C\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C" + fieldName + "\u5FC5\u987B\u5728" + minValue + "\u548C" + maxValue + "\u4E4B\u95F4");
                row[field] = minValue;
            }
            if (parseFloat(value) > maxValue) {
                this.$message.error("\u8BF7\u8F93\u5165\u6570\u5B57\uFF0C\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C" + fieldName + "\u5FC5\u987B\u5728" + minValue + "\u548C" + maxValue + "\u4E4B\u95F4");
                row[field] = maxValue;
            }
        }
    };
    CategoryTable.prototype.save = function (row) {
        var current = row.current;
        var next = row.next;
        if (!current.goods_price && !next.goods_price)
            return this.$message.error('定价不可为空，请设置定价后保存');
        if (current.ee_time === '长期有效') {
            current.ee_time = '';
        }
        if (next.ee_time === '长期有效') {
            next.ee_time = '';
        }
        var noCurrentTime = current.goods_price && !current.es_time;
        var noCurrentPrice = !current.goods_price && current.es_time;
        var noNextTime = next.goods_price && !next.es_time;
        var noNextPrice = !next.goods_price && next.es_time;
        if (noCurrentTime || noCurrentPrice || noNextTime || noNextPrice)
            return this.$message.error('请填写定价并为定价设置生效日期');
        var paramsData = [{
                supplier_upper_goods_id: row.supplier_upper_goods_id,
                tax_rate: row.tax_rate,
                current: {
                    goods_price: row.current.goods_price || '',
                    es_time: row.current.es_time || '',
                    ee_time: row.current.ee_time || ''
                },
                next: {
                    goods_price: row.next.goods_price || '',
                    es_time: row.next.es_time || '',
                    ee_time: row.next.ee_time || '',
                    reason: row.next.reason || ''
                }
            }];
        row.isEdit = !row.isEdit;
        this.$emit('saveItem', paramsData, row.supplier_upper_id);
    };
    CategoryTable.prototype.batchSave = function () {
        var list = [];
        this.data.forEach(function (row) {
            var paramsData = {
                supplier_upper_id: row.supplier_upper_id,
                supplier_upper_goods_id: row.supplier_upper_goods_id,
                tax_rate: row.tax_rate,
                current: {
                    goods_price: row.current.goods_price || '',
                    es_time: row.current.es_time || '',
                    ee_time: row.current.ee_time || ''
                },
                next: {
                    goods_price: row.next.goods_price || '',
                    es_time: row.next.es_time || '',
                    ee_time: row.next.ee_time || '',
                    reason: row.next.reason || ''
                }
            };
            list.push(paramsData);
        });
        this.batchCancel(false);
        this.$emit('batchSaveItem', list);
    };
    CategoryTable.prototype.edit = function (row) {
        row.isEdit = true;
        if (row.current.ee_time === '长期有效') {
            row.current.ee_time = '';
        }
        if (row.next.ee_time === '长期有效') {
            row.next.ee_time = '';
        }
    };
    CategoryTable.prototype.batchEdit = function () {
        var _this = this;
        this.isAllEdit = true;
        this.data.forEach(function (row) {
            _this.edit(row);
        });
    };
    CategoryTable.prototype.cancel = function (row, is_emit) {
        if (is_emit === void 0) { is_emit = true; }
        row.isEdit = false;
        if (row.current.ee_time === '') {
            row.current.ee_time = '长期有效';
        }
        if (row.next.ee_time === '') {
            row.next.ee_time = '长期有效';
        }
        if (is_emit) {
            this.$emit('cacelItem');
        }
    };
    CategoryTable.prototype.batchCancel = function (isAllEmit) {
        var _this = this;
        if (isAllEmit === void 0) { isAllEmit = true; }
        this.isAllEdit = false;
        this.data.forEach(function (row, index) {
            var is_emit = false;
            if ((_this.data.length - 1) == index && isAllEmit) {
                is_emit = true;
            }
            _this.cancel(row, is_emit);
        });
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], CategoryTable.prototype, "data", void 0);
    __decorate([
        Prop({
            type: Number
        }),
        Prop({
            default: document.documentElement.clientHeight - 230,
        })
    ], CategoryTable.prototype, "tableHeight", void 0);
    CategoryTable = __decorate([
        Component
    ], CategoryTable);
    return CategoryTable;
}(Vue));
export default CategoryTable;
